import { openModal } from '@members/modal/redux';
import type { Source } from '@members/stacks/analytics';

const STACK_MODAL_NAME = 'stackFromNav';
export const openStackFromNav = (source: Source) => openModal(STACK_MODAL_NAME, source);
